import React from "react";
import firebase from '../util/firebase.js';
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import Col from 'react-bootstrap/Col'
import Row from "react-bootstrap/Row";
import SmallCard from './SmallCard.js'
import PageLoader from './PageLoader.js'
import "./CoffeeCardSection.scss";
import { useWindowScrollPosition } from "../util/router.js";
// import { useLocation } from "../util/router.js";


function CoffeeCardSection(props) {
  const coffeeQuery = firebase.firestore().collection('coffee').orderBy('coffeeReviewAvg', 'desc').orderBy('coffeeReviewsNumTotal', 'desc');
  const [coffees, loading, error] = useCollectionDataOnce(coffeeQuery, { idField: 'id' });
  useWindowScrollPosition('MyAwesomeComponent_ScrollY', !loading);
  

  return ( 
    <Section
    bg={props.bg}
    textColor={props.textColor}
    size={props.size}
    bgImage={props.bgImage}
    bgImageOpacity={props.bgImageOpacity}
  >
    
    <Container>
      <SectionHeader
        title={props.title}
        subtitle={props.subtitle}
        size={2}
        spaced={true}
        className="text-center"
    />

    {error && console.log(error)}
    {loading && <PageLoader />}

    <Row className="justify-content-center">
      {coffees && coffees.map(coffee => 
        <Col
          xs={10}
          sm={6}
          md={4}
          lg={3}
          className="py-2 px-2 d-flex align-items-stretch"
          key={coffee.id}
        >

          <SmallCard coffee={coffee} />

        </Col>

        )}
      </Row>
   
    </Container>
  </Section>
);
}

export default CoffeeCardSection


